const FEMALE = new Set([
    'alice',
    'amy',
    'anna',
    'ashley',
    'barbara',
    'betty',
    'brenda',
    'carol',
    'catherine',
    'chloe',
    'christina',
    'claire',
    'cynthia',
    'deborah',
    'diana',
    'donna',
    'doris',
    'elizabeth',
    'elena',
    'emily',
    'emma',
    'eva',
    'grace',
    'hannah',
    'helen',
    'isabella',
    'jane',
    'janet',
    'jennifer',
    'jessica',
    'joan',
    'joyce',
    'judith',
    'julia',
    'karen',
    'katherine',
    'kelly',
    'kimberly',
    'laura',
    'linda',
    'lisa',
    'lucy',
    'margaret',
    'maria',
    'marie',
    'mary',
    'michelle',
    'nancy',
    'natalie',
    'nicole',
    'olivia',
    'pamela',
    'patricia',
    'rachel',
    'rebecca',
    'ruth',
    'sandra',
    'sarah',
    'sharon',
    'shirley',
    'sophia',
    'stephanie',
    'susan',
    'theresa',
    'victoria',
    'virginia',
].map((s) => s.toLowerCase()));
const MALE = new Set([
    'adam',
    'alan',
    'alexander',
    'andrew',
    'anthony',
    'austin',
    'benjamin',
    'brian',
    'bruce',
    'carl',
    'charles',
    'christopher',
    'daniel',
    'david',
    'dennis',
    'donald',
    'douglas',
    'edward',
    'eric',
    'ethan',
    'eugene',
    'frank',
    'gary',
    'george',
    'gerald',
    'gregory',
    'harold',
    'henry',
    'jack',
    'jacob',
    'james',
    'jason',
    'jeffrey',
    'jeremy',
    'jerry',
    'joe',
    'john',
    'jonathan',
    'jordan',
    'joseph',
    'joshua',
    'justin',
    'keith',
    'kenneth',
    'kevin',
    'larry',
    'lawrence',
    'logan',
    'louis',
    'marcus',
    'mark',
    'matthew',
    'michael',
    'mike',
    'nathan',
    'nicholas',
    'noah',
    'patrick',
    'paul',
    'peter',
    'philip',
    'raymond',
    'richard',
    'robert',
    'roger',
    'ronald',
    'ryan',
    'samuel',
    'scott',
    'sean',
    'stephen',
    'steven',
    'thomas',
    'timothy',
    'tyler',
    'vincent',
    'walter',
    'william',
    'willie',
].map((s) => s.toLowerCase()));
function firstToken(name) {
    const t = name.trim().split(/\s+/)[0] ?? '';
    return t.replace(/^[^a-zA-Z]+|[^a-zA-Z]+$/g, '').toLowerCase();
}
export function inferGenderHintFromName(name) {
    const token = firstToken(name);
    if (!token)
        return 'unknown';
    if (FEMALE.has(token))
        return 'female';
    if (MALE.has(token))
        return 'male';
    return 'unknown';
}
//# sourceMappingURL=genderHint.js.map